export default "__VITE_ASSET__XImcQXvQ__"